<template>
  <div class="index_ custom-tab">
    <div id="tab_"></div>
    <!-- 选项卡 -->
    <a-tabs :defaultActiveKey="0" @change="callback">
      <a-tab-pane v-for="(item, index) in product.tabDtos" :key="index" class="pane_" :tab="item.tabName" :forceRender="true">
        <div :style="`overflow: hidden;${expandContent ? 'height: auto;' : 'height: 600px;'}`">
          <div class="content_" v-html="item.tabContent" v-if="index != tabLen"></div>
          <div class="content_ bgColor" v-if="index == tabLen">
            <div class="flex item">
              <p class="name">
                承保公司：
              </p>
              <p class="val">
                {{ piluInfo.underCompanyName }}
              </p>
            </div>
            <div class="flex item">
              <p class="name">
                保司名称：
              </p>
              <p class="val">
                {{ piluInfo.companyName }}
              </p>
            </div>
            <div class="flex item">
              <p class="name">
                合作期限：
              </p>
              <p class="val">
                {{ piluInfo.cooperationStartDate }}
                至
                {{ piluInfo.cooperationEndDate }}
              </p>
            </div>
            <div class="flex item">
              <p class="name">
                合作范围：
              </p>
              <p class="val">
                {{ piluInfo.cooperationScope }}
              </p>
            </div>
            <div class="flex item detail">
              <p class="name">
                详细信息：
              </p>
              <p class="val">
                {{ piluInfo.insuranceNoticeInfo }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="item.tabContent && (item.tabContent.length > 300 || item.tabContent.indexOf('img') > -1)" class="spread_">
          <button class="inner-btn" :class="expandContent ? 'hide-btn' : ''" @click="handleExpandDetail">
             {{ expandContent ? '收起全部' : '展开全部' }}
            <img src="@/assets/image/down.png" class="icon_" />
          </button>
        </div>
        <div class="bottom_"></div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      piluInfo: {}, //批漏信息
      expandContent: false //是否展示
    };
  },
  computed: {
    tabLen() {
      return this.product.tabDtos ? this.product.tabDtos.length - 1 : 0;
    }
  },
  mounted() {
    const { p } = this.$route.query;
    if (p) {
      this.$api.queryPiluInfo(p).then(res => {
        //获取纰漏信息
        if (res.data.returnCode == 0) {
          this.piluInfo = res.data.data || {};
        }
      });
    }
  },
  methods: {
    callback(key) {
      //切换tab回调
      console.log(key);
      const perc = key * 100 + 0.001 + '%';
      let si = setTimeout(() => {
        console.log('1 -> ', document.getElementsByClassName('ant-tabs-content')[0].style);
        document.getElementsByClassName('ant-tabs-content')[0].style = `margin-left: -${perc};`;
        clearTimeout(si);
      }, 400);
    },
    handleExpandDetail() {
      //展开全部
      this.expandContent = !this.expandContent;
      if (!this.expandContent) {
        location.hash = '';
        location.hash = 'tab_';
      }
    }
  }
};
</script>

<style lang="scss">
.custom-tab {
  .ant-tabs-nav {
    width: 100%;

    div {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .ant-tabs-tab {
        width: 25%;
        margin: 0;
        padding: 24px 16px;
        font-size: 17px;
        font-weight: 600;
      }

      .ant-tabs-tab-active {
        color: #fe8f2d !important;
      }
    }
  }
}

.pane_ {
  font-size: 12px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);

  img {
    height: auto;
  }
}

.bgColor {
  background-color: rgb(252, 246, 238);
  padding: 10px;

  p {
    line-height: 20px;
  }

  .bold_ {
    font-weight: bold;
  }
}

.content_ p img {
  height: auto;
  width: 100%;
}

.content_ {
  min-height: 85px;
}

.content_ img {
  height: auto;
}

.spread_ {
  font-size: 13px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: rgba(254, 143, 45, 1);
  margin: 30px 0;
  text-align: right;

  .inner-btn {
    cursor: pointer;
    width: 200px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #EA9A57;
    .icon_ {
      width: 12px;
      margin-left: 6px;
    }
  }
  .hide-btn {
    .icon_ {
      transform: rotate(180deg) ;
    }
  }
}

.flex {
  display: flex;
  align-items: center;

  &.item {
    .name {
      min-width: 65px;
    }
  }

  &.detail {
    align-items: initial;
  }
}
</style>
